import React, {useEffect, useState} from 'react'
import {DealerFormStage} from '../modules/DealerFormStage'
import {useDispatch, useSelector} from 'react-redux'
import {RootState} from '../rootReducer'
import {Editorial} from '../modules/Editorial'
import {Breakpoints} from '@volkswagen-onehub/components-core'
import styled from 'styled-components'
import {DealerFaq} from '../modules/DealerFaq'
import {Form} from '../modules/Form'
import {closeLayers} from '../../shared/utilities'
import {
    DealerFormSelection,
    getDealerFormSelection,
} from '../../shared/dealerFormSelectionStorage'
import {useFeatureServices} from '../../use-feature-services'
import isEmpty from 'lodash.isempty'
import {layerLoadTracking} from '../../shared/trackingServiceHelper'
import {useTranslation} from 'react-i18next'
import {
    setDealerImageListing,
    setDealerSimulation,
    setPromoIndex,
} from '../../features/dealerFormData/dealerFormDataSlice'
import {AppDispatch} from '../thunk'
import type {SingleSimulation} from '../../types/SingleSimulation'

type DealerFormLocationState = Partial<DealerFormSelection>

const ContentContainer = styled.div`
    padding: 0 ${(props) => props.theme.size.grid002};
    margin-top: ${(props) => props.theme.size.dynamic0350};

    @media (min-width: ${Breakpoints.b560}px) {
        padding: 0 ${(props) => props.theme.size.grid001};
    }
    @media (min-width: ${Breakpoints.b1280}px) {
        padding: 0 ${(props) => props.theme.size.grid003};
    }
    @media (min-width: ${Breakpoints.b2560}px) {
        padding: 0 ${(props) => props.theme.size.grid006};
    }
`

export function DealerForm(): React.JSX.Element {
    const {t} = useTranslation('fa-flotte')
    const dispatch = useDispatch() as AppDispatch
    const {'s2:history': historyService} = useFeatureServices() as any
    const locationState = historyService.history.location
        .state as DealerFormLocationState
    const [storedSelection] = useState(() => getDealerFormSelection())

    const dealerSimulation = useSelector(
        (state: RootState) => state.dealerFormData.dealerSimulation
    )

    const image = useSelector(
        (state: RootState) => state.dealerFormData.dealerImageListing
    )

    const selectedDealerSimulation = !isEmpty(dealerSimulation)
        ? (dealerSimulation as SingleSimulation)
        : locationState?.dealerSimulation || storedSelection?.dealerSimulation

    const selectedImage =
        image ||
        locationState?.dealerImageListing ||
        storedSelection?.dealerImageListing ||
        ''

    useEffect(() => {
        const selectedLocationState = locationState?.dealerSimulation
            ? locationState
            : storedSelection

        if (
            isEmpty(dealerSimulation) &&
            selectedLocationState?.dealerSimulation
        ) {
            dispatch(
                setDealerSimulation(selectedLocationState.dealerSimulation)
            )

            if (selectedLocationState.dealerImageListing) {
                dispatch(
                    setDealerImageListing(
                        selectedLocationState.dealerImageListing
                    )
                )
            }

            if (selectedLocationState.promoIndex !== undefined) {
                dispatch(setPromoIndex(selectedLocationState.promoIndex))
            }

            return
        }

        if (isEmpty(dealerSimulation)) {
            historyService.history.push('/')
        }
    }, [])

    useEffect(() => {
        if (!selectedDealerSimulation) {
            return
        }

        closeLayers()
        layerLoadTracking(
            t('dealer-form.tracking', {model: selectedDealerSimulation.model})
        )
    }, [])

    if (!selectedDealerSimulation) {
        return <></>
    }

    return (
        <>
            <DealerFormStage
                promoData={selectedDealerSimulation}
                image={selectedImage}
            ></DealerFormStage>
            <ContentContainer>
                <Editorial />
                <Form simulationId={selectedDealerSimulation.id} />
                <DealerFaq />
            </ContentContainer>
        </>
    )
}
